<template>
    <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
        {{ status }}
    </div>


    <Heading
        :label="__('Login')"
        :description="__('Login to your account')"
        type="h1"
        class="text-center"
    />

    <form  class="grid grid-cols-1 gap-3" @submit.prevent="submit">
        <InputLabel
            :label="__('Email')"
            id="email"
            type="email"
            v-model="form.email"
            autocomplete="email"

        />
        <InputLabel
            :label="__('Password')"
            id="password"
            type="password"
            v-model="form.password"
            autocomplete="current-password"
        />

        <Checkbox
            name="remember"
            :label="__('Remember me')"
            v-model="form.remember"
        />

        <div class="flex items-center justify-between mt-4">
            <InertiaLink v-if="canResetPassword" :href="route('password.request')" class="underline text-sm text-gray-600 hover:text-gray-900">
                {{__('Forgot your password?')}}
            </InertiaLink>

            <div>
            <InertiaLink v-if="route().current('login')" :href="route('register')" class="ml-4 text-sm text-gray-700 underline">
                {{__('Register')}}
            </InertiaLink>

            <breeze-button class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                {{ __('Log in') }}
            </breeze-button>
            </div>
        </div>
    </form>
</template>

<script>
    import BreezeButton from 'UI/Button'
    import BreezeGuestLayout from "@/Layouts/Guest"
    import BreezeValidationErrors from 'COMP/ValidationErrors'

    import InputLabel from 'UI/InputLabel';
    import Heading from 'COMP/Heading';
    import Checkbox from 'UI/Checkbox';

    export default {
        layout: BreezeGuestLayout,

        components: {
            BreezeButton,
            BreezeValidationErrors,
            InputLabel,
            Heading,
            Checkbox,
        },

        props: {
            canResetPassword: Boolean,
            status: String,
        },

        data() {
            return {
                form: this.$inertia.form({
                    email: '',
                    password: '',
                    remember: false
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('login'), {
                    onFinish: () => this.form.reset('password'),
                })
            }
        }
    }
</script>

